<template>
    <div>
      <div class="logistics">
        <div
          class="header acea-row row-between row-top"
          style="padding: 0.23rem 0.3rem;background-color: #fff;"
        >
          <div class="pictrue">
            <img :src="newCartInfo.image_path" />
          </div>
          <div class="text acea-row row-between">
            <div class="name line2">
              {{ newCartInfo.product_name }}
            </div>
            <div class="money">
      
              <div>x{{ newCartInfo.number }}</div>
            </div>
          </div>
  
  
          <!-- </template> -->
          <div class="logisticsCon">
            <div
              class="company acea-row row-between-wrapper"
            >
              <div class="picTxt acea-row row-between-wrapper">
                <div class="iconfont icon-wuliu"></div>
                <div class="text">
                  <div>
                    <span class="name line1"
                      >物流公司：{{
                        newCartInfo.express_cp
                      }}</span
                    >
                  </div>
                  <div class="express line1">
                    <span class="name">快递单号： {{ newCartInfo.express_no }}</span>
                   
                  </div>
                </div>
              </div>
              <div
                class="copy acea-row row-center-wrapper copy-data"
                :data-clipboard-text="
                  newCartInfo.express_no
                "
              >
                复制单号
              </div>
            </div>
  
            <div>
              <div
                class="xq"
                @click="isshow(inx)"
                style="width:6.9rem; margin:0 auto;">
                <span v-if="!newCartInfo.is_show">点击查看详情</span>
                <span class="down" v-if="!newCartInfo.is_show">︾</span>
  
                <span v-if="newCartInfo.is_show">收起</span>
                <span class="down" v-if="newCartInfo.is_show">︽</span>
              </div>
            </div>
  
            <div
        
            >
              <div v-if="expose.status !== '0'"
                class="item xq">
                :( 暂未查到与您单号相关的物流信息，请稍后再尝试。
              </div>
    
               <div
                class="item" 
                v-for="(express, index) in expressList"
                :key="index"
               
              >
                <div v-if="newCartInfo.is_show" >
                  <div class="circular" :class="index === 0 ? 'on' : ''"></div>
                <div class="text">
                  <div :class="index === 0 ? 'font-color-red' : ''">
                    {{ express.status }}
                  </div>
                  <div class="data">{{ express.time }}</div>
                </div>
                </div>
              </div>
   
            </div>
          </div>

          <div v-if="expressList.length ==0">
            <div class="logisticsCon">
              <div class="company acea-row row-between-wrapper">
                <div class="picTxt acea-row row-between-wrapper">
                  <div class="iconfont icon-wuliu"></div>
                  <div class="text">
                    <div>
                      <span class="name line1" style="width:100%;"
                        >此商品暂未发货，我们正在加紧处理</span
                      >
                    </div>
                    <div class="express line1">
                      <span class="name">再次深感抱歉，请您耐心等待</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Recommend></Recommend>
      </div>
    </div>
  </template>
  <script>
  import Recommend from "@components/Recommend";
  import ClipboardJS from "clipboard";
  import { dgExpress } from "@api/cake";

  const NAME = "Logistics";
  
  export default {
    name: NAME,
    components: {
      Recommend,
    },
    data: function() {
      return {
        id: this.$route.params.id,
        newCartInfo: [],
        orderInfo: {},
        expressList: [],
        loaded: false,
        is_show: false,
        expose:{}
      };
    },
    watch: {
      $route(n) {       
        if (n.name === NAME && this.$route.params.id !== this.id) {
          this.id = this.$route.params.id;
          this.getExpress();
        }
      }
    },
    mounted: function() {
      this.getExpress();
    },
    methods: {
      isshow() {
        var that = this;
        var listData = that.newCartInfo;
        var is_show = that.newCartInfo.is_show; 
        listData.is_show = !is_show;
        that.newCartInfo = listData;
      },
      getExpress() {
        if (!this.id) return this.$dialog.error("订单不存在");
        this.loaded = false;
        dgExpress(this.id)
          .then(res => {
            const result = res.data.express.result || {};
            var newCartInfo = res.data.order; // 先用一个变量接收对象
            newCartInfo.is_show=false
            this.newCartInfo = newCartInfo; // 把变量赋值给全局变量
            this.expressList = result.list || [];
            this.expose=res.data.express
            this.loaded = true;
  
            //复制
            this.$nextTick(function() {
              var copybtn = document.getElementsByClassName("copy-data");
              const clipboard = new ClipboardJS(copybtn);
              clipboard.on("success", () => {
                this.$dialog.success("复制成功");
              });
            });
          })
          .catch(e => {
            this.$dialog.error(e.msg || "加载失败");
          });
      }
    }
  };
  </script>
  
  <style scoped>
  .logisticsListBox {
    background: rgba(255, 255, 255);
    box-sizing: border-box;
    margin: 0.3rem 0 0 0.5rem;
    /* border-left:.05rem solid #2374;
    border-top:.05rem solid #2374; */
  }
  
  .no-express {
    margin: 1.5rem 0;
  }
  
  .no-express img {
    width: 6rem;
    margin: 0 auto;
    display: block;
  }
  
  .active {
    display: none;
  }
  .xq {
    width: 100%;
    text-align: center;
    font-size: 0.2rem;
    color: #999;
    padding-bottom: 0.3rem;
    position: relative;
  }
  .down {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
  }
  </style>
  